export default "__VITE_ASSET__66c60ecc__"